export default "__VITE_ASSET__D8PuHvx1__"